/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-4
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {refreshSearch, uncheckSubAggregations} from './search-common.js';
import {handlePaginationActions} from './search-pagination.js';

/**
 * Rafraichit le corps de la recherche.
 * @param event {Event} - L'événement.
 */
async function refreshSearchBody(event) {
    if (event) event.preventDefault();
    await refreshSearch('search-body');
    handleDesktopActions();
}

/**
 * Gère la sélection des inputs de recherche sur desktop.
 */
function handleDesktopSearchInputSelection() {
    const searchinputs = document.querySelectorAll('.js-desktop-search-aggregation input, .js-desktop-search-sort');
    searchinputs.forEach((input) => {
        input.addEventListener('change', refreshSearchBody);
    });
}

/**
 * Simulation de l'activation d'un radio bouton pour les facettes à valeur unique
 * @param event Événement de clic reçu
 */
function updateCheckedItemForExclusiveInputSelection(event) {
    event.target.closest('.pop-list').querySelectorAll('.k-radio').forEach((radio) => {
        radio.checked = false;
    });
    const kradio = event.target.closest('.js-desktop-search-aggregation-exclusive').querySelector('.k-radio');
    if (kradio) {
        kradio.checked = true;
        if (kradio.name === 'types') {
            uncheckSubAggregations(event);
        }
    }
    refreshSearchBody();
}

/**
 * Mise à jour de l'interface au clic sur une facette à valeur unique
 */
function handleDesktopSearchExclusiveInputSelection() {
    const searchinputs = document.querySelectorAll('.js-desktop-search-aggregation-exclusive');
    searchinputs.forEach((input) => {
        input.addEventListener('click', updateCheckedItemForExclusiveInputSelection);
        input.addEventListener('keydown', (event) => {
            if ([ 'Enter', 'Spacebar', ' ', 13, 10 ].includes(event.key ?? event.keyCode)) {
                event.preventDefault();
                input.click();
            }
        });
    });
}

/**
 * Supprime un filtre de recherche sur desktop.
 * @param e {string} - La clé du filtre à supprimer.
 */
async function removeDesktopFilter(e) {
    const aggregation = document.querySelector(`.js-desktop-search-aggregation input#${e}`);
    if (aggregation) {
        aggregation.checked = false;
    }
    const chip = document.querySelector(`.js-search-desktop-chip[data-key="${e}"]`);
    if (chip) {
        chip.remove();
    }
    await refreshSearch('search-body');
}

/**
 * Gère la fermeture des chips de filtres sur desktop.
 */
function handleDesktopChipClose() {
    const chips = document.querySelectorAll('.js-search-desktop-chip');
    chips.forEach((chip) => {
        chip.querySelector('.chip__close').addEventListener('click', async () => {
            await removeDesktopFilter(chip.getAttribute('data-key'));
        });
    });
}

/**
 * Supprime tous les filtres de recherche sur desktop.
 */
async function removeDesktopFilters() {
    document.querySelectorAll('.js-desktop-search-aggregation input').forEach(function (checkbox) {
        checkbox.checked = false;
    });
    document.querySelectorAll('.js-search-desktop-chip').forEach(function (chip) {
        chip.remove();
    });
    await refreshSearch('search-body');
}

/**
 * Gère le nettoyage des filtres de recherche sur desktop.
 */
function handleDesktopCleanFilters() {
    const cleanFilters = document.querySelector('.js-search-desktop-clean-filters');
    if (cleanFilters) {
        cleanFilters.addEventListener('click', removeDesktopFilters);
    }
}

/**
 * Rafraichit la recherche sur lors de l'appui sur le bouton de recherche sur desktop.
 */
function handleDesktopSearchButton() {
    const searchButton = document.querySelector('.js-search-send-form');
    if (searchButton) {
        searchButton.addEventListener('click', refreshSearchBody);
    }
}

/**
 * Gère les actions desktop.
 */
export function handleDesktopActions() {
    handleDesktopSearchInputSelection();
    handleDesktopSearchExclusiveInputSelection();
    handleDesktopChipClose();
    handleDesktopCleanFilters();
    handleDesktopSearchButton();
    handlePaginationActions();
}

handleDesktopActions();
